import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ar_XA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  'a24413d6-3c93-423f-a9d3-4abbd5a4fa09',
  'rtl'
);
